import type { Series } from './series';

/** Deflate `amount` by `i` inflation rate over `t` years. */
export function realValue(amount: number, i: number, t: number): number {
  return amount / Math.pow(1 + i, t);
}

/** Fisher equation: real return from nominal rate and inflation rate. */
export function realReturn(nominal: number, inflation: number): number {
  return (1 + nominal) / (1 + inflation) - 1;
}

/**
 * Return a new Series with each point's value deflated by `i` per year,
 * using the point's `t` as the elapsed years. Preserves the series `id`.
 */
export function inflationAdjustedSeries(series: Series, i: number): Series {
  return {
    id: series.id,
    points: series.points.map((p) => ({
      t: p.t,
      value: p.value / Math.pow(1 + i, p.t),
    })),
  };
}
